module.exports = __webpack_public_path__ + "static/media/globofilmes.35e4f672.png";